import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { ITeam } from '@core/interfaces/team.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TeamService {
  constructor(private readonly http: HttpClient) {}

  public getTeams(params?: HttpParams): Observable<IApiResponse<ITeam[]>> {
    return this.http.get<IApiResponse<ITeam[]>>('teams', { params });
  }

  public createTeam(payload: { name: string; iconId?: string | null }): Observable<ITeam> {
    return this.http.post<ITeam>('teams', payload);
  }

  public updateTeam(id: string, payload: { name: string; iconId?: string | null }): Observable<ITeam> {
    return this.http.put<ITeam>(`teams/${id}`, payload);
  }

  public deleteTeam(id: string): Observable<ITeam> {
    return this.http.delete<ITeam>(`teams/${id}`);
  }
}
